{
  "localeInternationalCountryCode": "US",
  "PhoneInput": {
    "placeholder": "Enter phone number",
    "emptyDisplay": "-"
  },
  "CountryInput": {
    "placeholder": "Select country",
    "emptyCountries": "No countries found",
    "emptyDisplay": "-",
    "groupCommon": "Common",
    "groupAllCountries": "All Countries"
  }
}
